import './SelectOnMapButton.css'
import finger from '../../imgs/select_on_map_finger.png'

interface ISelectOnMapButtonProps {
    onClick: () => void
}

export default function SelectOnMapButton(props: ISelectOnMapButtonProps) {
    return <button className="Select_on_map_button" onClick={(e) => props.onClick()}>
        <span className="Select_on_map_button__title">На карте</span>
        <img src={finger} className="Select_on_map_button__icon"/>
    </button>
}